import * as Yup from "yup";

export default function AddBehaviorValidationSchema() {
  return Yup.object().shape({
    name: Yup.string().required('Required'),
    behaviorCategoryId: Yup.string().required('Required')
  });
}
